import FirstLayerHome from './FirstLayerHome/FirstLayerHome';
import NewsLayerHome from './NewsLayerHome/NewsLayerHome';
import Footer from '../../commons/Footer/Footer';
// import ReadyLayerHome from "./ReadyLayerHome/ReadyLayerHome"
import IntroLayerHome from './IntroLayerHome/IntroLayerHome';
import { Helmet } from 'react-helmet';
import Menu from '../../commons/Menu/Menu';
import '../../../styles/Home.css';
import { useEffect } from 'react';
import { useIsDev } from '../../../hooks/useIsDev/useIsDev';

export default () => {

  const IS_DEV = useIsDev()

  useEffect(() => {
    if (!IS_DEV) {
      // @ts-ignore
      window.location = 'https://publiconsult.fr'
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>PubliConsult</title>
      </Helmet>
      <Menu />
      <FirstLayerHome />
      <IntroLayerHome />
      <NewsLayerHome />
      {/* <ReadyLayerHome /> */}
      <Footer />
    </>
  );
};
